import React from 'react';
import Icon from '../AppIcon';
import { useParams } from 'react-router-dom';


const BookingProgressNavigation = ({ 
  currentStep = 1, 
  totalSteps = 3, 
  canGoBack = false, 
  canGoForward = false,
  onBack,
  onForward,
  steps = [
    { label: 'Select Date', path: '/date-selection' },
    { label: 'Choose Time', path: '/time-slot-selection' },
    { label: 'Your Details', path: '/client-details-form' }
  ]
}) => {

  const { companyPath } = useParams();
  return (
    <div className="sticky top-0 z-50 bg-card shadow-sm border-b border-border">
      <div className="max-w-4xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between gap-4">
        <button
            onClick={() => {
              if (currentStep === 1) {
                window.location.href = `/${companyPath}`; 
              } else {
                onBack?.();
              }
            }}
            disabled={currentStep !== 1 && !canGoBack}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-250 ease-elegant ${
              currentStep === 1 || canGoBack
                ? 'text-primary hover:bg-primary/10 hover:scale-105 active:scale-95'
                : 'text-muted-foreground opacity-50 cursor-not-allowed'
            }`}
            aria-label="Go back to previous step"
          >
            <Icon name="ChevronLeft" size={20} />
            <span className="hidden sm:inline font-caption">Back</span>
          </button>


          <div className="flex-1 flex items-center justify-center gap-2 sm:gap-4">
            {steps?.map((step, index) => {
              const stepNumber = index + 1;
              const isActive = stepNumber === currentStep;
              const isCompleted = stepNumber < currentStep;

              return (
                <React.Fragment key={stepNumber}>
                  <div className="flex flex-col items-center gap-2">
                    <div
                      className={`w-10 h-10 rounded-full flex items-center justify-center font-caption font-medium transition-all duration-250 ease-elegant ${
                        isActive
                          ? 'bg-primary text-primary-foreground shadow-md scale-110'
                          : isCompleted
                          ? 'bg-success text-success-foreground'
                          : 'bg-muted text-muted-foreground'
                      }`}
                    >
                      {isCompleted ? (
                        <Icon name="Check" size={20} />
                      ) : (
                        stepNumber
                      )}
                    </div>
                    <span
                      className={`hidden md:block text-xs font-caption transition-colors duration-250 ${
                        isActive
                          ? 'text-primary font-medium'
                          : isCompleted
                          ? 'text-success' :'text-muted-foreground'
                      }`}
                    >
                      {step?.label}
                    </span>
                  </div>
                  {stepNumber < totalSteps && (
                    <div
                      className={`hidden sm:block w-12 md:w-20 h-0.5 transition-colors duration-250 ${
                        isCompleted ? 'bg-success' : 'bg-muted'
                      }`}
                    />
                  )}
                </React.Fragment>
              );
            })}
          </div>

          <button
            onClick={onForward}
            disabled={!canGoForward}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-250 ease-elegant ${
              canGoForward
                ? 'text-primary hover:bg-primary/10 hover:scale-105 active:scale-95' :'text-muted-foreground opacity-50 cursor-not-allowed'
            }`}
            aria-label="Continue to next step"
          >
            <span className="hidden sm:inline font-caption">Next</span>
            <Icon name="ChevronRight" size={20} />
          </button>
        </div>

        <div className="mt-3 text-center">
          <p className="text-sm text-muted-foreground font-caption">
            Step {currentStep} of {totalSteps}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BookingProgressNavigation;